class SearchOverlay extends DrupalBehavior {
  onContent(context) {
    once('init-header-search', '.header--search', context)
      .forEach((searchOverlay) => {
        this.searchToggle = document.querySelector('.header--search-toggle');
        this.mobileMenuToggle = document.querySelector('.header--mobile-toggle');
        this.search = document.querySelector('.header--search');
        this.bindEvents();
        this.init();
      });

  }

  bindEvents() {
    this.toggleSearch = this.toggleSearch.bind(this);
    this.triggerClose = this.triggerClose.bind(this);
  }

  openSearch() {
    this.search.classList.remove('hidden');
    gsap.to(this.search, { duration: 0.4, ease: 'power4.out', height: 'auto' });
    this.search.querySelector('input[type="text"]').focus();
  }

  closeSearch() {
    gsap.to(this.search, { duration: 0.4, ease: 'power4.out', height: 0, onComplete: function() {
      this.search.classList.add('hidden');
    }.bind(this) });
  }

  triggerClose() {
    this.searchToggle.classList.remove('open');
    this.searchToggle.setAttribute('aria-expanded', false);
    this.closeSearch();
  }

  toggleSearch() {
    this.searchToggle.classList.toggle('open');
    if (this.searchToggle.classList.contains('open')) {
      this.searchToggle.setAttribute('aria-expanded', true);
      this.openSearch();
    } else {
      this.searchToggle.setAttribute('aria-expanded', false);
      this.closeSearch();
    }
    document.dispatchEvent(new CustomEvent('summit:searchToggled'));
  }

  init() {
    this.searchToggle.classList.remove('open');
    this.searchToggle.setAttribute('aria-haspopup', true);
    this.searchToggle.setAttribute('aria-expanded', false);
    this.search.classList.add('hidden');
    this.search.style.height = 0;

    this.searchToggle.addEventListener('click', this.toggleSearch, true);
    if (this.mobileMenuToggle) {
      this.mobileMenuToggle.addEventListener('click', this.triggerClose, true);
    }
    document.addEventListener('summit:mobileMenuOpened', this.triggerClose);
  }

}

DrupalBehavior.register('summit_theme', 'SearchOverlay', SearchOverlay);